import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SmoothScroll, scrollToSection } from './components/SmoothScroll';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { AvisoLegal } from './pages/AvisoLegal';
import { Privacidad } from './pages/Privacidad';
import { Cookies } from './pages/Cookies';
import { NotFound } from './pages/NotFound';
import { SocialMedia } from './pages/SocialMedia';
import './App.css';

// Enlaces como /#contacto desde otras páginas: el ancla no existe hasta que React
// pinta, así que el salto del navegador no llega a producirse.
const useScrollToHash = () => {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const t = setTimeout(() => scrollToSection(id, { immediate: true }), 100);
    return () => clearTimeout(t);
  }, []);
};

const Home = () => {
  useScrollToHash();
  return (
    <SmoothScroll>
      <div className="App bg-[#0A0A0A] text-white">
        <Navbar />
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <ContactSection />
        <Footer />
      </div>
    </SmoothScroll>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/social-media" element={<SocialMedia />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;